import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import axios from "axios";
import {
  Plus,
  Search,
  User,
  X,
  ArrowRightLeft,
} from "lucide-react";

import PageWrapper from "../components/PageWrapper";

export default function Crew() {
  const [creators, setCreators] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedCrew, setSelectedCrew] = useState(null);

  const [openMutasi, setOpenMutasi] = useState(false);

const [mutasiForm, setMutasiForm] = useState({
  kode_toko: "",
  id_jabatan: "",
});

const [tokoList, setTokoList] = useState([]);

  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    name: "",
    jabatan: "",
    status: "Aktif",
  });

  /* =======================
     FETCH DATA
  ======================= */
  const fetchCreators = async () => {
    try {
      setLoading(true);

      const token = localStorage.getItem("token");
      const kode_toko = localStorage.getItem("kode_toko");

      const res = await axios.get(`/api/setting/crew`, {
        params: { kode_toko },
        headers: {
          "x-api-key": "SECRET123456",
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.data.success) {
        setCreators(res.data.data);
      }
    } catch (err) {
      console.log("Gagal fetch crew:", err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCreators();
  }, []);


  const submitMutasi = async () => {
  try {
    await axios.post(
      "/api/setting/crew/mutasi",
      {
        id_sunfish: selectedCrew.id_sunfish,
        kode_toko: mutasiForm.kode_toko,
        id_jabatan: mutasiForm.id_jabatan,
      },
      {
        headers: {
          "x-api-key": "SECRET123456",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    setOpenMutasi(false);
    setSelectedCrew(null);
    fetchCreators(); // refresh data
  } catch (err) {
    console.log(err.message);
  }
};

  const fetchToko = async () => {
  try {
    const res = await axios.get("/api/master/toko", {
      headers: {
        "x-api-key": "SECRET123456",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    if (res.data.success) {
      setTokoList(res.data.data);
    }
  } catch (err) {
    console.log(err.message);
  }
};

useEffect(() => {
  fetchToko();
}, []);


  const filtered = creators.filter((c) =>
    (c.nama || "").toLowerCase().includes(search.toLowerCase())
  );

  /* =======================
     ADD CREW
  ======================= */
  const addCreator = async () => {
  try {
    if (!form.nama || !form.id_sunfish) return;
const kode_toko = localStorage.getItem("kode_toko");
    await axios.post(
      "/api/setting/crew/add",
      {
        id_sunfish: form.id_sunfish,
        nama: form.nama,
        id_jabatan: form.id_jabatan,
        tanggal_masuk: form.tanggal_masuk,
        kode_toko
      },
      {
        headers: {
          "x-api-key": "SECRET123456",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    setOpen(false);
    setForm({
      id_sunfish: "",
      nama: "",
      id_jabatan: "",
      tanggal_masuk: "",
      status: "Aktif",
    });

    fetchCreators();
  } catch (err) {
    console.log("Gagal add crew:", err.message);
  }
};

  /* =======================
     TOGGLE STATUS
  ======================= */
const toggleStatus = async () => {
  try {
    const newStatus =
      selectedCrew.status === "Aktif" ? "Nonaktif" : "Aktif";

    await axios.post(
      "/api/setting/crew/update-status",
      {
        id_sunfish: selectedCrew.id_sunfish,
        status: newStatus,
      },
      {
        headers: {
          "x-api-key": "SECRET123456",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    const updated = creators.map((item) =>
      item.id_sunfish === selectedCrew.id_sunfish
        ? { ...item, status: newStatus }
        : item
    );

    setCreators(updated);

    setSelectedCrew({
      ...selectedCrew,
      status: newStatus,
    });

  } catch (err) {
    console.log("Gagal update status:", err.message);
  }
};

  /* =======================
     MODAL ADD (PORTAL)
  ======================= */
 const renderAddModal = () =>
  createPortal(
    open && (
      <div className="fixed inset-0 z-[99999] bg-black/50 backdrop-blur-sm flex items-center justify-center p-4">
        <div
          onClick={(e) => e.stopPropagation()}
          className="bg-white rounded-3xl w-full max-w-md p-6 shadow-2xl space-y-4"
        >
          <div className="flex items-center justify-between">
            <h2 className="text-xl font-bold">Tambah Crew</h2>
            <button onClick={() => setOpen(false)}>
              <X />
            </button>
          </div>

          {/* ID SUNFISH */}
          <input
            placeholder="ID Sunfish"
            value={form.id_sunfish}
            onChange={(e) =>
              setForm({ ...form, id_sunfish: e.target.value })
            }
            className="w-full border rounded-2xl p-3"
          />

          {/* NAMA */}
          <input
            placeholder="Nama Crew"
            value={form.nama}
            onChange={(e) =>
              setForm({ ...form, nama: e.target.value })
            }
            className="w-full border rounded-2xl p-3"
          />

          {/* JABATAN */}
          <select
            value={form.id_jabatan}
            onChange={(e) =>
              setForm({ ...form, id_jabatan: e.target.value })
            }
            className="w-full border rounded-2xl p-3"
          >
            <option value="">Pilih Jabatan</option>
            <option value="1">STORE LEADER</option>
            <option value="2">WAKIL STORE LEADER</option>
            <option value="3">KASIR</option>
            <option value="4">SALES ADVISOR</option>
            <option value="5">VM STORE</option>
            <option value="6">STAFF GUDANG</option>
          </select>

          {/* TANGGAL MASUK */}
          <div>
            <label className="text-sm text-gray-500">
              Tanggal Masuk Kerja
            </label>
            <input
              type="date"
              value={form.tanggal_masuk}
              onChange={(e) =>
                setForm({ ...form, tanggal_masuk: e.target.value })
              }
              className="w-full border rounded-2xl p-3 mt-1"
            />
          </div>

          {/* ACTION */}
          <div className="flex justify-end gap-3 pt-2">
            <button
              onClick={() => setOpen(false)}
              className="px-4 py-2 border rounded-2xl"
            >
              Cancel
            </button>

            <button
              onClick={addCreator}
              className="bg-rose-500 text-white px-5 py-2 rounded-2xl"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    ),
    document.body
  );

  /* =======================
     MODAL DETAIL (PORTAL)
  ======================= */
  const renderDetailModal = () =>
    createPortal(
      selectedCrew && (
        <div className="fixed inset-0 z-[99999] bg-black/50 backdrop-blur-sm flex items-center justify-center p-4">
          <div className="bg-white rounded-3xl w-full max-w-lg shadow-2xl overflow-hidden">

            {/* HEADER */}
            <div className="bg-gradient-to-r from-rose-500 to-pink-500 p-6 text-white relative">
              <button
                onClick={() => setSelectedCrew(null)}
                className="absolute top-4 right-4"
              >
                <X />
              </button>

              <div className="flex items-center gap-4">
                <div className="w-20 h-20 rounded-2xl bg-white/20 flex items-center justify-center">
                  <User size={32} />
                </div>

                <div>
                  <h2 className="text-2xl font-bold">
                    {selectedCrew.nama}
                  </h2>
                  <p className="text-white/80">
                    {selectedCrew.jabatan}
                  </p>
                </div>
              </div>
            </div>

            {/* CONTENT */}
            <div className="p-6 space-y-5">

              {/* STATUS */}
              <div className="flex items-center justify-between bg-gray-50 p-4 rounded-2xl">

                <div>
                  <p className="text-sm text-gray-500">Status</p>

                  <div className="flex items-center gap-2 mt-1">
                    <div
                      className={`w-3 h-3 rounded-full ${
                        selectedCrew.status === "Aktif"
                          ? "bg-green-500"
                          : "bg-red-500"
                      }`}
                    />
                    <span
                      className={
                        selectedCrew.status === "Aktif"
                          ? "text-green-600 font-semibold"
                          : "text-red-500 font-semibold"
                      }
                    >
                      {selectedCrew.status}
                    </span>
                  </div>
                </div>

                {/* SWITCH */}
                <button
                  onClick={toggleStatus}
                  className={`w-16 h-8 flex items-center rounded-full p-1 transition ${
                    selectedCrew.status === "Aktif"
                      ? "bg-green-500"
                      : "bg-gray-300"
                  }`}
                >
                  <div
                    className={`w-6 h-6 bg-white rounded-full shadow transform transition ${
                      selectedCrew.status === "Aktif"
                        ? "translate-x-8"
                        : "translate-x-0"
                    }`}
                  />
                </button>
              </div>

              {/* DETAIL */}
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-gray-50 p-4 rounded-2xl">
                  <p className="text-sm text-gray-500">Jabatan</p>
                  <p className="font-semibold">
                    {selectedCrew.jabatan}
                  </p>
                </div>

                <div className="bg-gray-50 p-4 rounded-2xl">
                  <p className="text-sm text-gray-500">ID</p>
                  <p className="font-semibold">
                    {selectedCrew.id_sunfish}
                  </p>
                </div>
              </div>

             {selectedCrew?.status === "Aktif" && (
  <button
    onClick={() => setOpenMutasi(true)}
    className="w-full bg-blue-500 text-white py-3 rounded-2xl flex items-center justify-center gap-2"
  >
    <ArrowRightLeft size={18} />
    Mutasi
  </button>
)}
            </div>
          </div>
        </div>
      ),
      document.body
    );

  return (
    <PageWrapper>
      <div className="space-y-5">

        {/* HEADER */}
        <div className="flex justify-between items-center">
          <h1 className="text-xl font-bold">Data Crew</h1>

          <button
            onClick={() => setOpen(true)}
            className="bg-rose-500 text-white px-4 py-2 rounded-2xl flex items-center gap-2"
          >
            <Plus size={18} />
            Add
          </button>
        </div>

        {/* SEARCH */}
         <div className="bg-white border border-gray-200 rounded-2xl px-4 py-3 flex items-center gap-3 shadow-sm">

          <Search size={18} className="text-gray-400" />

          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Cari crew..."
            className="w-full outline-none text-sm"
          />

        </div>

        {/* LIST */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {filtered.map((c, index) => (
            <div
              key={c.id_sunfish || index}
              onClick={() => setSelectedCrew(c)}
              className="bg-white border border-gray-100 rounded-3xl p-5 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all cursor-pointer"
            >

              {/* TOP */}
              <div className="flex items-start justify-between">

                <div className="w-14 h-14 rounded-2xl bg-rose-100 flex items-center justify-center">
                  <User className="text-rose-500" size={24} />
                </div>

                <span
                  className={`text-xs px-3 py-1 rounded-full font-semibold ${
                    c.status === "Aktif"
                      ? "bg-green-100 text-green-700"
                      : "bg-red-100 text-red-600"
                  }`}
                >
                  {c.status || "-"}
                </span>

              </div>

              {/* BODY */}
              <div className="mt-4">

                <h3 className="font-semibold text-lg text-gray-800">
                  {c.nama}
                </h3>

                <p className="text-sm text-gray-500 mt-1">
                  {c.jabatan || "Tidak ada jabatan"}
                </p>

              </div>

            </div>
          ))}
        </div>

        {/* MODALS */}
        {renderAddModal()}
        {renderDetailModal()}
      </div>

      {openMutasi &&
  createPortal(
    <div
      onClick={() => setOpenMutasi(false)}
      className="fixed inset-0 z-[99999] bg-black/50 backdrop-blur-sm flex items-center justify-center p-4"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white w-full max-w-md rounded-3xl p-6 space-y-4"
      >
        <h2 className="text-xl font-bold">Mutasi Crew</h2>

        {/* PILIH TOKO */}
        <div>
          <label className="text-sm text-gray-500">Pilih Toko</label>
          <select
            className="w-full border p-3 rounded-2xl mt-1"
            value={mutasiForm.kode_toko}
            onChange={(e) =>
              setMutasiForm({
                ...mutasiForm,
                kode_toko: e.target.value,
              })
            }
          >
            <option value="">Pilih Toko</option>
            {tokoList.map((t) => (
              <option key={t.kode_toko} value={t.kode_toko}>
                {t.nama_toko}
              </option>
            ))}
          </select>
        </div>

        {/* PILIH JABATAN */}
        <div>
          <label className="text-sm text-gray-500">Jabatan Baru</label>
          <select
            className="w-full border p-3 rounded-2xl mt-1"
            value={mutasiForm.id_jabatan}
            onChange={(e) =>
              setMutasiForm({
                ...mutasiForm,
                id_jabatan: e.target.value,
              })
            }
          >
            <option value="">Pilih Jabatan</option>
            <option value="1">STORE LEADER</option>
            <option value="2">WAKIL STORE LEADER</option>
            <option value="3">KASIR</option>
            <option value="4">SALES ADVISOR</option>
            <option value="5">VM STORE</option>
            <option value="6">STAFF GUDANG</option>
          </select>
        </div>

        {/* ACTION */}
        <div className="flex gap-3 pt-2">
          <button
            onClick={() => setOpenMutasi(false)}
            className="flex-1 border py-3 rounded-2xl"
          >
            Cancel
          </button>

          <button
            className="flex-1 bg-blue-500 text-white py-3 rounded-2xl"
          >
            Proses Mutasi
          </button>
        </div>
      </div>
    </div>,
    document.body
  )}

    </PageWrapper>
  );
}